<template>
  <div>
    <v-container>
       <v-row>
        <v-col cols='12' md='4'>
          <equipment-basics
            v-if='item'
            :item='item'
            @update='update'
          ></equipment-basics>
        </v-col>
        <v-col cols='12' md='4'>
          <equipment-details 
            v-if='item'
            :item='item'
            @update='update'
          ></equipment-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from './Basics'
import Details from './Details'

export default {
  name: 'equipment-overview',
  props: {
    item: {
      required: true
    }
  },
  components: {
    'equipment-basics': Basics,
    'equipment-details': Details
  },
  methods: {
    update (item) {
      this.$emit('update', item)
    },
  }
}
</script>
